import {SVGProps} from "types/SVG";

export const DamageWide = ({alt, className}: SVGProps) => (
    <svg width="165" height="165" viewBox="0 0 165 165" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <title>{alt}</title>
        <g clip-path="url(#clip0_3545_20917)">
            <path d="M165.371 89.5977H-0.373047V165.373H165.371V89.5977Z" fill="url(#paint0_linear_3545_20917)"/>
            <mask id="mask0_3545_20917" maskUnits="userSpaceOnUse" x="-1" y="-1" width="167"
                  height="167">
                <path d="M165.371 -0.373047H-0.373047V165.371H165.371V-0.373047Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_3545_20917)">
                <path
                    d="M165.371 58.1641L-0.37326 58.1641V-15.9613C-0.37326 -16.8724 0.365585 -17.6113 1.27675 -17.6113L163.721 -17.6113C164.632 -17.6113 165.371 -16.8724 165.371 -15.9613V58.1641Z"
                    fill="url(#paint1_linear_3545_20917)"/>
                <path
                    d="M164.758 128.103L156.988 58.0133L173.917 56.6328C185.205 56.7648 195.318 70.1426 197.465 89.499C199.61 108.853 192.989 125.854 181.689 126.723L164.76 128.103H164.758Z"
                    fill="#37556D"/>
                <path
                    d="M164.766 128.094C175.625 126.889 182.687 110.222 180.54 90.8671C178.393 71.512 167.85 56.798 156.991 58.0026C146.133 59.2071 139.071 75.874 141.218 95.2291C143.365 114.584 153.908 129.298 164.766 128.094Z"
                    fill="#37556D"/>
                <path
                    d="M162.712 122.071C171.914 121.227 178.202 107.775 176.758 92.0243C175.313 76.2738 166.683 64.1896 157.481 65.0335C148.28 65.8774 141.991 79.3298 143.436 95.0803C144.88 110.831 153.511 122.915 162.712 122.071Z"
                    fill="#37556D"/>
                <path
                    d="M162.437 120.765C170.761 120.002 176.391 107.205 175.013 92.1824C173.636 77.1599 165.771 65.6006 157.448 66.3639C149.124 67.1273 143.494 79.9243 144.872 94.9468C146.249 109.969 154.114 121.529 162.437 120.765Z"
                    fill="#686F7F"/>
                <path
                    d="M162.202 118.193C169.737 117.502 174.835 105.915 173.588 92.313C172.34 78.7112 165.22 68.245 157.684 68.9361C150.148 69.6272 145.05 81.214 146.298 94.8158C147.545 108.418 154.666 118.884 162.202 118.193Z"
                    fill="#2B2A44"/>
                <path
                    d="M173.776 95.6882L165.876 91.0407L171.046 81.1627C170.568 79.9307 170.034 78.7757 169.458 77.6922L165.093 82.4918L165.066 71.8292C164.393 71.2168 163.7 70.6797 162.985 70.2507C162.356 73.954 162.11 84.4242 162.11 84.4242C160.635 81.4487 158.838 73.0685 158.068 68.9013C157.938 68.9068 157.808 68.8903 157.676 68.9013C156.812 68.9802 155.985 69.2185 155.19 69.5705C155.983 77.7325 159.085 85.8982 159.085 85.8982C156.244 84.3288 152.023 78.8783 149.484 75.3565C148.936 76.363 148.45 77.4722 148.023 78.6583C151.046 84.0062 156.515 91.334 156.515 91.334L146.104 92.2873C146.133 93.1252 146.186 93.9722 146.265 94.8283C146.393 96.2217 146.597 97.571 146.841 98.891C150.084 99.0542 155.941 99.001 155.941 99.001L150.445 109.519C151.503 111.493 152.705 113.208 154.02 114.575C156.401 110.494 160.635 106.039 160.635 106.039C160.635 106.039 160.026 113.198 159.896 118.095C160.655 118.251 161.423 118.326 162.197 118.255C162.585 118.22 162.963 118.137 163.339 118.044C163.586 112.075 164.661 105.808 164.661 105.808C164.661 105.808 167.35 111.435 169.083 113.831C169.667 113.035 170.205 112.15 170.692 111.18C168.144 105.773 166.987 101.032 166.987 101.032L173.532 100.935C173.719 99.2522 173.803 97.4977 173.774 95.6882H173.776Z"
                    fill="#686F7F"/>
                <path
                    d="M161.928 99.6383C163.786 99.4678 165.043 96.6103 164.736 93.2557C164.428 89.9011 162.672 87.3198 160.814 87.4902C158.956 87.6607 157.699 90.5183 158.006 93.8728C158.314 97.2274 160.07 99.8087 161.928 99.6383Z"
                    fill="#8691A0"/>
                <path
                    d="M133.18 25.1715L134.353 12.7012C134.496 11.3042 135.686 10.25 137.09 10.2738L143.479 10.3838C145.109 10.4113 146.411 11.7552 146.385 13.385L146.224 25.375L133.18 25.1715Z"
                    fill="url(#paint2_linear_3545_20917)"/>
                <path
                    d="M138.627 17.7977C138.744 17.0754 139.118 16.4301 139.661 15.9662L134.351 12.6992L133.18 25.1696L137.589 25.2392L138.627 17.7977Z"
                    fill="#7196B5"/>
                <path
                    d="M34.6486 29.4429L24.2463 31.7089L-51.9434 26.1099L-51.4612 16.3603L-37.9569 -4.12358C-36.679 -5.53158 -34.9172 -6.39875 -33.0234 -6.55091C-22.3112 -7.41075 8.30181 -7.08075 14.4911 -2.73758C21.3203 2.05475 34.579 29.1111 34.722 29.4026L34.6486 29.4429Z"
                    fill="#4B6C8C"/>
                <path
                    d="M213.713 88.2751L215.924 65.2961V57.1432L210.149 51.2784L204.023 50.9997L44.1935 29.4104C44.1935 29.4104 34.8545 8.04108 23.948 -4.29542C14.7887 -14.6556 -25.8068 -12.1018 -36.2403 -11.0164C-38.2552 -10.8074 -40.1307 -9.90542 -41.557 -8.46625L-64.47 20.2712V23.6702L-70.1387 32.1091L-62.0922 48.1471L-48.542 52.4902L-37.8702 92.9904L35.0103 105.789C37.1077 94.6038 33.0303 86.0989 33.0303 86.0989C33.2027 74.5232 36.7062 67.3036 38.5065 64.3428C39.1445 63.2941 49.215 74.8698 50.4305 74.6992C58.796 73.5241 58.95 65.5784 62.6093 67.5621C63.9733 68.3027 65.1137 69.3881 65.9148 70.7173C68.1313 74.3931 70.5513 80.9564 72.5918 87.2484C75.747 96.9761 77.3493 107.138 77.3493 117.365V120.844C80.3028 121.55 84.1528 122.126 88.3457 122.595C91.7465 122.975 95.151 121.737 98.7077 121.988C101.478 122.184 104.428 123.891 106.972 124.021C115.024 124.434 121.258 124.549 121.258 124.549C154.43 123.167 200.945 114.968 212.433 112.869C214.089 112.567 215.484 111.469 216.169 109.932L219.977 101.415C220.269 100.762 220.236 100.01 219.889 99.3851L213.711 88.2714L213.713 88.2751ZM24.2468 31.7113L-49.8198 23.5474C-51.0353 23.2962 -51.8768 22.1852 -51.7888 20.9478L-51.7008 19.7157C-51.545 17.5451 -50.6668 15.4881 -49.2038 13.8766L-37.9582 -4.12309C-36.6803 -5.53109 -34.9185 -6.39825 -33.0247 -6.55042C-22.3143 -7.41025 8.3005 -7.08025 14.4898 -2.73709C21.319 2.05525 34.5777 29.1116 34.7207 29.4031L34.6473 29.4434L24.245 31.7094L24.2468 31.7113Z"
                    fill="url(#paint3_linear_3545_20917)"/>
                <path
                    d="M12.3164 81.4232C12.3164 82.0355 35.0094 105.786 35.0094 105.786L77.3484 120.844C77.3484 120.844 78.6372 107.647 76.0596 92.634C73.8504 79.764 67.7931 64.7545 67.0414 64.661C65.4116 64.4575 26.1764 52.6875 26.1764 52.6875L12.3164 81.425V81.4232Z"
                    fill="#2C3E54"/>
                <path
                    d="M59.9904 137.641L52.2207 67.5504L69.1497 66.1699C80.4375 66.3019 90.5502 79.6798 92.697 99.0361C94.842 118.391 88.2219 135.391 76.9212 136.26L59.9922 137.641H59.9904Z"
                    fill="#37556D"/>
                <path
                    d="M60.0008 137.636C70.8593 136.431 77.9213 119.764 75.7742 100.409C73.6271 81.054 63.084 66.34 52.2255 67.5446C41.367 68.7491 34.305 85.416 36.4521 104.771C38.5992 124.126 49.1423 138.84 60.0008 137.636Z"
                    fill="#4B6C8C"/>
                <path
                    d="M57.9487 131.614C67.1504 130.77 73.4388 117.318 71.9943 101.567C70.5498 85.8168 61.9194 73.7326 52.7177 74.5765C43.5161 75.4204 37.2276 88.8728 38.6721 104.623C40.1166 120.374 48.747 132.458 57.9487 131.614Z"
                    fill="#37556D"/>
                <path
                    d="M57.6715 130.312C65.9949 129.549 71.6255 116.752 70.2478 101.729C68.87 86.7068 61.0057 75.1474 52.6822 75.9108C44.3588 76.6742 38.7282 89.4711 40.1059 104.494C41.4837 119.516 49.348 131.076 57.6715 130.312Z"
                    fill="url(#paint4_linear_3545_20917)"/>
                <path
                    d="M57.4359 127.74C64.9718 127.048 70.0697 115.462 68.8223 101.86C67.5748 88.258 60.4545 77.7918 52.9185 78.483C45.3825 79.1741 40.2847 90.7608 41.5321 104.363C42.7796 117.965 49.8999 128.431 57.4359 127.74Z"
                    fill="#37556D"/>
                <path
                    d="M57.3421 111.155C59.8033 110.929 61.4682 107.145 61.0608 102.702C60.6534 98.2596 58.3279 94.8412 55.8666 95.0669C53.4054 95.2926 51.7404 99.077 52.1479 103.519C52.5553 107.962 54.8808 111.38 57.3421 111.155Z"
                    fill="#4B6C8C"/>
                <path
                    d="M54.7344 55.6198L60.0235 55.1963C60.0235 55.1963 67.0049 45.6776 71.447 42.5041C75.8892 39.3306 80.9657 43.9854 80.9657 43.9854C80.9657 43.9854 87.5235 59.6403 103.813 63.4481C120.102 67.2559 79.9079 71.0638 79.9079 71.0638L54.7344 55.6216V55.6198Z"
                    fill="url(#paint5_linear_3545_20917)"/>
                <path
                    d="M134.014 93.929L138.674 90.4163C142.73 87.3601 147.57 85.5231 152.631 85.1198L202.903 81.1103C205.882 80.872 208.757 81.9793 210.807 84.0363L213.17 73.0308L206.099 59.95C205.314 58.498 203.741 57.651 202.097 57.794L148.336 62.4653C146.851 62.5936 145.47 63.2848 144.477 64.3976L130.371 80.1863L134.016 93.929H134.014Z"
                    fill="#547B9B"/>
                <path
                    d="M75.6971 41.666C75.6971 41.666 77.0886 45.9597 77.6918 49.8207C78.0695 52.2407 78.1098 55.4215 78.1098 55.4215L83.4705 58.7673L86.7081 58.9562C86.7081 58.9562 88.9338 58.9562 89.8541 59.233C89.8596 59.233 95.5998 63.1013 96.6228 63.358L107.729 65.1565L119.787 69.3879C122.953 70.321 133.214 67.2722 134.774 65.9302L138.705 57.0367L75.6953 41.666H75.6971Z"
                    fill="#4B6C8C"/>
                <path
                    d="M78.5391 44.0508C78.5391 44.0508 79.2302 45.9593 79.8334 49.8203C80.2111 52.2403 80.2514 55.4211 80.2514 55.4211L85.3279 58.0244L91.1982 57.8649C91.1982 57.8649 91.0772 58.9558 91.9976 59.2326C92.0031 59.2326 97.7432 63.1009 98.7662 63.3576L109.873 65.1561L121.93 69.3875C123.927 69.888 133.216 67.2718 134.777 65.9298L140.849 57.0363L78.5391 44.0508Z"
                    fill="url(#paint6_linear_3545_20917)"/>
                <path
                    d="M139.545 57.2845L127.503 67.0616C125.907 68.3596 123.778 68.7978 121.796 68.2405L97.3707 61.3618C88.6954 58.9198 81.7031 52.4903 78.5406 44.0515L77.8164 42.1191L139.547 57.2826L139.545 57.2845Z"
                    fill="url(#paint7_linear_3545_20917)"/>
                <path
                    d="M88.9824 44.998L90.1484 50.0562C90.4454 51.3432 91.4391 52.3534 92.7206 52.6724L132.926 62.6915L139.582 57.4354L88.9843 44.9999L88.9824 44.998Z"
                    fill="#4B6C8C"/>
                <path
                    d="M70.0837 55.6785L60.0242 55.1982L43.6214 47.324L31.0209 46.1214L28.2122 44.7188L-54.6728 27.3535L-39.4103 38.1188L-49.017 39.2684L-70.1406 32.1074L-69.8198 72.855L-66.6371 72.635L-62.7871 51.8762C-62.4205 49.8962 -60.3983 48.6898 -58.4825 49.304L-53.4958 50.9027C-50.4121 51.8908 -48.0453 54.3842 -47.2203 57.5155L-37.874 92.9887L35.0065 105.787C35.2412 93.2454 33.0265 86.0972 33.0265 86.0972C33.1989 74.5252 36.7005 67.3074 38.5009 64.3447C39.1407 63.2924 41.5607 60.5332 41.5607 60.5332L64.2702 63.8607L70.0782 55.6767L70.0837 55.6785Z"
                    fill="url(#paint8_linear_3545_20917)"/>
                <path
                    d="M-40.2949 85.6826L-37.8676 92.9885L35.0129 105.787C35.0716 102.712 34.9799 99.9661 34.8131 97.5663L-40.2949 85.6826Z"
                    fill="#2C3E54"/>
                <path
                    d="M64.7024 70.8483C64.7024 70.8483 70.5508 80.9555 72.5931 87.2475C75.3101 95.624 76.8263 103.511 77.2076 112.296L79.4626 114.991L117.121 115.761L94.2796 102.453L101.188 76.638L116.949 78.5483L130.059 71.435L118.619 70.3203L104.924 66.1421L96.6923 65.363L83.4519 62.4388L71.9221 57.4668L64.2734 63.8596L64.7006 70.8465L64.7024 70.8483Z"
                    fill="url(#paint9_linear_3545_20917)"/>
                <path
                    d="M81.2559 77.6709L84.4825 78.9029C84.4825 78.9029 92.4667 83.1727 93.3137 85.9227L89.0329 93.8519C89.0329 93.8519 86.5432 80.2101 81.2559 77.6727V77.6709Z"
                    fill="#F09063"/>
                <path
                    d="M85.8621 69.219C85.8621 69.219 86.3205 66.8008 87.9741 64.6228C89.5251 62.5787 92.299 60.7765 91.7068 60.5217C90.5701 60.0303 88.1318 60.5932 84.4248 62.2633C78.1383 65.0977 73.357 64.2708 71.1148 63.6017C67.934 66.5185 65.2793 70.0917 65.2793 70.0917C65.657 71.7013 68.9808 75.8025 68.9808 75.8025C68.9808 75.8025 73.8978 95.5017 79.132 92.0623C84.533 88.513 88.3518 95.7235 89.032 93.8517C90.3153 90.3188 83.9463 79.6067 84.4816 78.9027C90.0348 71.6042 93.586 71.3897 96.3085 68.3335C99.0016 65.3122 85.8603 69.219 85.8603 69.219H85.8621Z"
                    fill="url(#paint10_linear_3545_20917)"/>
                <path
                    d="M85.7115 63.1948C86.069 64.6633 85.8619 69.221 85.8619 69.221C85.8619 69.221 86.3202 66.8028 87.9739 64.6248C89.5249 62.5806 92.2987 60.7785 91.7065 60.5236C90.5699 60.0323 88.1315 60.5951 84.4245 62.2653C84.2669 62.3368 84.1129 62.3955 83.957 62.4615C84.8627 62.5055 85.5905 62.698 85.7115 63.1948Z"
                    fill="url(#paint11_linear_3545_20917)"/>
                <path
                    d="M68.3109 74.9476C68.7069 75.461 68.9801 75.802 68.9801 75.802C68.9801 75.802 69.0223 75.9743 69.1048 76.2823C69.4018 75.186 70.7804 70.4413 72.7128 68.9967C77.9488 65.0825 83.9548 62.459 83.9548 62.459C77.8993 65.0458 73.2976 64.2538 71.1123 63.5993C68.3366 66.1458 65.8359 69.356 65.2768 70.0893C65.2126 70.1828 67.3979 73.0538 68.3091 74.9476H68.3109Z"
                    fill="url(#paint12_linear_3545_20917)"/>
                <path
                    d="M77.2071 112.295L79.4621 114.99L117.121 115.76L110.033 112.003C107.761 111.866 105.296 111.697 102.736 111.499C99.5096 111.248 95.0583 108.998 91.7271 108.663C88.0604 108.292 85.5213 109.829 82.2268 109.376C80.3898 109.123 78.6536 108.859 77.0586 108.584C77.1154 109.403 77.1723 111.462 77.2071 112.296V112.295Z"
                    fill="#7196B5"/>
                <path
                    d="M12.6919 17.261L-0.949908 17.4883C-2.58891 17.5158 -3.99874 18.6543 -4.37091 20.2511L-5.65607 25.7768C-6.12907 27.81 -4.76507 29.8156 -2.70074 30.1218L11.8156 32.2778C14.2099 32.6335 16.3348 34.003 17.6474 36.0361L18.0911 36.7236C18.6319 37.5615 19.5174 38.117 20.5074 38.238L22.5333 38.4855C23.8294 38.6431 25.0853 37.9648 25.6591 36.7915L26.7261 34.6171L22.5058 28.8146V28.1381C22.5058 24.7208 20.9951 21.4776 18.3771 19.2795C16.7858 17.943 14.7673 17.2261 12.6901 17.261H12.6919Z"
                    fill="url(#paint13_linear_3545_20917)"/>
                <path
                    d="M-5.21484 23.8744L17.216 29.7135C19.086 30.2012 20.7103 31.3599 21.7773 32.9714L24.9307 37.7307C25.2258 37.4704 25.4788 37.1587 25.6603 36.7902L26.7273 34.6159L22.507 28.8134L-4.87934 22.4297L-5.21484 23.8744Z"
                    fill="url(#paint14_linear_3545_20917)"/>
                <path
                    d="M22.5075 28.8146C22.4855 28.7706 22.4855 28.7175 22.5075 28.6551V28.1381C22.5075 24.7208 20.9969 21.4776 18.3789 19.2795C16.7875 17.943 14.769 17.2261 12.6919 17.261L-0.949953 17.4883C-2.58895 17.5158 -3.99879 18.6543 -4.37095 20.2511L-4.87695 22.4291L22.5075 28.8128V28.8146Z"
                    fill="url(#paint15_linear_3545_20917)"/>
                <path
                    d="M22.8633 -5.26299L103.966 -5.91016C103.966 -5.91016 114.695 -1.74482 144.12 24.294L44.1923 29.4108C44.1923 29.4108 34.6039 7.12668 22.8633 -5.26299Z"
                    fill="#4B6C8C"/>
                <path
                    d="M22.8633 -5.26299L103.966 -5.91016C103.966 -5.91016 114.695 -1.74482 144.12 24.294L44.1923 29.4108C44.1923 29.4108 34.6039 7.12668 22.8633 -5.26299Z"
                    fill="#4B6C8C"/>
                <g opacity="0.25">
                    <path
                        d="M43.3454 27.5219L44.6269 29.3864L124.951 25.2742C110.807 15.6419 94.1947 6.61453 77.8469 0.069526C74.3086 -1.34764 70.4714 -2.17081 66.5517 -2.23131C66.0366 -2.23864 65.5214 -2.24414 65.0044 -2.24414H25.5254C34.0284 8.02069 41.0061 22.4234 43.3472 27.5219H43.3454Z"
                        fill="white"/>
                </g>
                <g opacity="0.25">
                    <path
                        d="M44.1926 29.4096L96.9046 26.7109C82.8851 17.6029 67.0048 9.17876 51.3169 2.89777C49.9823 2.36427 48.5981 1.94077 47.1956 1.57227H28.4883C37.5156 13.9069 44.1908 29.4096 44.1908 29.4096H44.1926Z"
                        fill="white"/>
                </g>
                <path
                    d="M103.763 -4.27849C103.763 -4.27849 114.07 -0.274489 142.179 24.3948L144.12 24.2958C114.695 -1.74482 103.968 -5.91016 103.968 -5.91016L22.8652 -5.26299C23.3602 -4.74049 23.8497 -4.19966 24.3356 -3.64599L103.763 -4.28032V-4.27849Z"
                    fill="#2C3E54"/>
                <path
                    d="M143.954 25.4119C144.064 25.4064 144.174 25.4137 144.282 25.4357L173.031 31.2932C181.259 33.0422 189.237 35.8142 196.776 39.5469C201.559 41.9137 204.425 46.9481 204.021 52.2684L139.58 57.4311L104.484 49.9107L89.1869 45.4484L78.6452 44.3741L64.0244 41.2409C58.6069 40.0804 44.7854 35.1854 44.1914 29.4086L143.954 25.4119Z"
                    fill="#4B6C8C"/>
                <path
                    d="M143.954 24.1424C144.064 24.1369 144.174 24.1442 144.282 24.1662L173.031 30.0237C181.259 31.7727 189.238 34.5447 196.776 38.2774C201.559 40.6442 204.425 45.6785 204.022 50.9989L138.775 55.848L122.026 52.3464L112.269 48.3002L104.314 49.732L94.0344 43.7902L80.178 41.1465L64.0264 39.9732C58.6089 38.8127 45.8452 34.6969 44.1934 29.4095L143.956 24.1424H143.954Z"
                    fill="url(#paint16_linear_3545_20917)"/>
                <path
                    d="M138.775 55.8482L150.696 58.2205C151.583 58.3855 152.491 58.4277 153.391 58.347L200.298 54.1579C200.999 54.0955 201.648 53.7619 202.106 53.2284L204.024 50.999L138.777 55.8482H138.775Z"
                    fill="#4B6C8C"/>
                <path
                    d="M132.759 89.199L130.37 80.1845L101.897 76.714L101.184 76.6406L103.512 88.9405L127.222 92.0095L132.759 89.199Z"
                    fill="url(#paint17_linear_3545_20917)"/>
                <path d="M94.2793 102.452L110.033 112.004L134.013 93.9289L103.512 88.9404L94.2793 102.452Z"
                      fill="url(#paint18_linear_3545_20917)"/>
                <path
                    d="M101.898 76.7139L103.513 88.9386L94.2788 102.452L91.4701 100.705C89.1601 99.2676 88.1481 96.4241 89.0318 93.8501L93.3126 85.9209L93.9066 79.6582C94.6418 77.5169 96.7575 76.1657 99.0106 76.4004L101.896 76.7139H101.898Z"
                    fill="url(#paint19_linear_3545_20917)"/>
                <path
                    d="M94.105 93.8499L99.2383 84.7034L99.6948 77.5736C99.8415 77.1464 100.118 76.7981 100.467 76.5506L99.0128 76.3984C96.7615 76.1638 94.6458 77.5149 93.9088 79.6563L93.3148 85.9189L89.034 93.8481C88.1503 96.4221 89.1605 99.2656 91.4723 100.703L94.2975 102.32L95.8338 100.179C94.0372 98.6423 93.3185 96.1398 94.105 93.8481V93.8499Z"
                    fill="#2C3E54"/>
                <path
                    d="M64.2749 63.8623L56.9526 61.3928L52.6974 61.0389L47.8556 58.3238L43.9616 57.0111C41.6717 56.2521 39.1564 56.9488 37.5669 58.7638C36.5292 59.9499 35.4622 61.2479 34.9086 62.1591C32.7141 65.7671 29.0071 73.6669 28.8219 86.0346L28.8164 87.0209L29.2271 87.8973C29.2601 87.9706 32.5307 95.8484 31.0201 105.096L35.0112 105.787C35.1707 92.0223 33.0312 86.0969 33.0312 86.0969C33.1431 75.4581 36.5366 68.3264 39.0354 64.5003C40.3756 62.4488 42.9092 61.5358 45.2467 62.2728L51.0071 65.0558L56.9562 66.3079L64.2767 63.8586L64.2749 63.8623Z"
                    fill="#7196B5"/>
                <path
                    d="M44.1934 29.4098L99.1805 36.8788L103.04 41.3155L119.569 41.6125L130.036 43.9371C132.415 44.3405 134.835 44.4468 137.242 44.258L186.898 40.3456C187.738 40.2796 187.885 39.11 187.085 38.8386L144.123 24.293L44.1952 29.4098H44.1934Z"
                    fill="url(#paint20_linear_3545_20917)"/>
                <path
                    d="M93.852 95.6553L89.375 98.4273C89.8462 99.3384 90.5538 100.134 91.4723 100.704L110.035 112.003L112.845 109.884L93.852 95.6553Z"
                    fill="#86B4EA"/>
                <path d="M101.898 76.7139L102.353 80.1312L116.95 78.549L101.898 76.7139Z" fill="#4B6C8C"/>
                <path
                    d="M209.253 80.7779C208.135 79.3076 206.344 78.5119 204.503 78.6677L146.359 83.6562C144.168 83.8707 142.038 84.4922 140.074 85.4877L127.225 92.0089L134.301 96.1504L213.712 88.2744L209.253 80.7779Z"
                    fill="url(#paint21_linear_3545_20917)"/>
                <path
                    d="M211.649 84.5586C210.219 82.0928 207.501 80.6664 204.659 80.8938L152.633 85.1196C147.571 85.5229 142.731 87.3599 138.675 90.4161L110.035 112.004L117.123 115.76C154.022 115.564 218.378 105.015 218.378 105.015L219.984 101.414C220.275 100.762 220.242 100.012 219.894 99.3866L211.651 84.5568L211.649 84.5586Z"
                    fill="#547B9B"/>
                <path
                    d="M119.473 115.604C112.836 115.358 88.8433 114.354 77.209 112.295L80.2981 121.48C82.6961 121.912 85.4388 122.285 88.3465 122.607C91.52 122.959 95.3865 121.747 98.7103 121.988C102.034 122.228 104.812 123.918 107.809 124.065C115.456 124.441 121.262 124.549 121.262 124.549C155.192 123.135 201.071 114.973 212.447 112.872C214.097 112.568 215.486 111.472 216.172 109.941L218.377 105.015C218.377 105.015 161.353 113.805 122.853 115.591C121.726 115.644 120.602 115.644 119.473 115.602V115.604Z"
                    fill="#7196B5"/>
                <path
                    d="M78.1105 55.4208V53.9395L70.0842 55.6775L64.366 58.5191L61.3447 56.4878L56.7852 59.841L56.9557 66.309L59.2033 66.199L64.4577 66.4813L64.2762 63.8615L66.4358 61.2288L73.0982 56.8673L78.1105 55.4208Z"
                    fill="url(#paint22_linear_3545_20917)"/>
                <path
                    d="M78.1092 55.4209L70.0828 57.1571L64.3647 60.0006L61.3433 57.9692L58.8262 61.5662L59.202 66.1991L64.4343 66.5492L64.2748 63.8616L68.1652 62.6442L73.0968 58.3469L79.464 56.2459L78.1092 55.4209Z"
                    fill="url(#paint23_linear_3545_20917)"/>
                <path
                    d="M79.4578 88.0365C78.3248 84.5458 72.3665 76.8348 72.3665 76.8348C72.3665 76.8348 65.3595 70.222 65.2807 70.0918C64.463 70.739 64.4135 72.9646 63.3887 74.8585C63.9992 75.3608 70.6212 82.4668 70.6212 82.4668C70.6212 82.4668 72.2657 86.7275 72.691 88.0401C75.4043 96.4075 78.5668 103.521 78.9518 112.295L82.2262 109.375C83.4233 109.694 85.5665 109.296 85.5665 109.296C85.5665 109.296 82.019 95.929 79.4578 88.0365Z"
                    fill="#2C3E54"/>
                <path
                    d="M76.6336 85.732C75.5006 82.2413 70.6203 76.8348 70.6203 76.8348C70.6203 76.8348 65.3586 70.222 65.278 70.0918C64.4603 70.739 62.6655 72.9646 61.6406 74.8585C62.2511 75.3608 68.8731 82.4668 68.8731 82.4668C68.8731 82.4668 70.5176 86.7275 70.943 88.0401C73.6563 96.4075 76.8188 103.521 77.2038 112.295L82.7331 112.775C82.372 103.429 79.5175 94.631 76.6318 85.732H76.6336Z"
                    fill="#7196B5"/>
                <path
                    d="M79.4044 42.1582L69.123 42.3342L77.4684 44.1217L77.923 44.1675L89.1889 45.4509L104.312 49.7335L93.895 44.8019L79.4044 42.1582Z"
                    fill="url(#paint24_linear_3545_20917)"/>
                <path
                    d="M112.458 49.8672L104.486 49.913L112.83 51.7024L122.182 54.434L132.106 58.2492L139.58 57.4334L121.765 53.147L112.458 49.8672Z"
                    fill="url(#paint25_linear_3545_20917)"/>
                <path d="M144.797 56.9003L151.857 58.5649L200.644 54.0439L168.04 54.6783L144.797 56.9003Z"
                      fill="#2C3E54"/>
                <path
                    d="M23.3914 88.6133C23.3914 88.6133 23.3291 88.6334 23.2246 88.6609C23.3273 88.6939 23.3896 88.6848 23.3914 88.6133Z"
                    fill="#4B6C8C"/>
                <path
                    d="M34.7226 29.4023L33.6006 29.6462C31.4849 32.8985 28.2142 44.7162 28.2142 44.7162C28.2142 44.7162 24.5567 63.3337 23.3926 88.6135L25.2956 95.626C26.4322 79.2653 28.7239 64.4978 29.4884 58.8823C30.2547 53.2668 33.0616 49.822 32.6784 48.9292C32.2952 48.0363 31.0192 46.1223 31.0192 46.1223L33.4447 36.424C34.4659 33.7437 34.7207 29.406 34.7207 29.406L34.7226 29.4023Z"
                    fill="#4B6C8C"/>
                <path
                    d="M34.6489 29.4434C32.5333 32.6957 29.4074 44.9955 29.4074 44.9955C29.4074 44.9955 25.5079 65.5674 24.3438 90.8472L26.1148 96.294C26.7491 76.5142 28.8098 63.8514 29.4881 58.8812C30.2544 53.2657 33.0613 49.8209 32.6781 48.928C32.2949 48.0352 31.0189 46.1212 31.0189 46.1212L33.4444 36.4229C34.4161 33.8745 34.6929 29.8339 34.7186 29.4434H34.6489Z"
                    fill="#2C3E54"/>
                <path d="M-40.4082 86.1073L-27.4942 84.7158L23.3918 88.6135L31.365 97.1367L-40.4082 86.1073Z"
                      fill="#7196B5"/>
                <path
                    d="M44.3882 49.6246C45.974 50.0206 61.3447 56.4904 61.3447 56.4904L60.0229 55.1979L43.62 47.3238L31.0195 46.1211L32.6787 48.9279C32.6787 48.9279 42.8005 49.2268 44.3864 49.6228L44.3882 49.6246Z"
                    fill="url(#paint26_linear_3545_20917)"/>
                <path
                    d="M56.5058 51.7298L60.0239 55.1948L68.0869 44.8805L69.1228 42.334L59.1696 47.9568L43.6211 47.3225L50.4998 50.6243L56.5058 51.7298Z"
                    fill="url(#paint27_linear_3545_20917)"/>
                <path
                    d="M43.621 47.3242L44.3873 49.625C45.9731 50.021 61.3438 56.4909 61.3438 56.4909L60.022 55.1984L56.5038 51.7334L50.4978 50.6279L43.6191 47.3261L43.621 47.3242Z"
                    fill="url(#paint28_linear_3545_20917)"/>
                <path
                    d="M104.385 54.9847L111.254 53.1349L107.85 50.5811L96.9964 55.3404L99.6969 56.7246L94.4297 59.5901L104.326 59.6891L104.385 54.9847Z"
                    fill="#E2F0FE"/>
                <path
                    d="M99.3281 54.3174L104.379 55.5751L104.386 54.9847L111.256 53.1349L107.851 50.5811L99.3281 54.3174Z"
                    fill="#89A6BD"/>
                <path
                    d="M96.9969 55.3412L107.85 50.5819L103.342 49.4434L94.3257 55.1817L97.4186 56.927L92.7051 59.5909L94.4302 59.6074L99.6974 56.7254L96.9969 55.3412Z"
                    fill="url(#paint29_linear_3545_20917)"/>
                <path
                    d="M103.038 41.3159L96.0562 38.8574L80.1777 41.1473L94.0341 43.7909L104.312 49.7346L107.373 47.1331L103.038 41.3159Z"
                    fill="url(#paint30_linear_3545_20917)"/>
                <path
                    d="M132.924 44.6182L120.232 41.9214L103.037 41.3164L123.563 45.8869L130.385 51.4401L138.774 55.8492L132.924 44.6182Z"
                    fill="url(#paint31_linear_3545_20917)"/>
                <path d="M112.269 48.3025L104.312 49.7343L107.374 47.1328L112.269 48.3025Z"
                      fill="url(#paint32_linear_3545_20917)"/>
                <path
                    d="M115.401 61.4509L116.293 58.5817L115.454 56.2992L113.217 57.2636L113.576 55.1846L103.236 63.0752L104.507 63.3851L109.926 61.6727L109.901 63.1211L115.401 61.4509Z"
                    fill="white"/>
                <path
                    d="M113.373 59.5207L115.454 56.2996L114.324 52.9629L103.236 63.0756L111.706 57.5389L111.985 59.8782L113.373 59.5207Z"
                    fill="white"/>
                <path d="M111.255 53.1352L103.236 63.0756L114.324 52.9629L111.255 53.1352Z"
                      fill="url(#paint33_linear_3545_20917)"/>
                <path
                    d="M113.373 59.521L111.985 59.8785L111.706 57.5391L103.236 63.0758L110.799 58.96V61.3836L114.026 60.2891L115.454 56.2998L113.373 59.521Z"
                    fill="url(#paint34_linear_3545_20917)"/>
                <path
                    d="M24.998 -5.22499C20.818 -9.95316 13.2152 -11.1998 -0.48899 -11.8617C-0.696156 -11.8708 -0.89599 -11.869 -1.09766 -11.869C9.24051 -11.2622 19.2505 -9.26199 23.6798 -4.25332C34.5863 8.08318 44.193 29.4122 44.193 29.4122L45.8962 29.3517C45.5112 28.4698 35.9247 7.13717 24.9998 -5.22316L24.998 -5.22499Z"
                    fill="#2C3E54"/>
            </g>
        </g>
        <defs>
            <linearGradient id="paint0_linear_3545_20917" x1="82.4991" y1="247.985" x2="82.4991" y2="57.5382"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#ECFFFF"/>
                <stop offset="0.3" stop-color="#E8FAFF"/>
                <stop offset="0.66" stop-color="#DEEBFF"/>
                <stop offset="1" stop-color="#CFD7FF"/>
            </linearGradient>
            <linearGradient id="paint1_linear_3545_20917" x1="82.4989" y1="-85.98" x2="82.4989" y2="21.9374"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#ECFFFF"/>
                <stop offset="0.46" stop-color="#F0FCFF"/>
                <stop offset="1" stop-color="#FFF4FF"/>
            </linearGradient>
            <linearGradient id="paint2_linear_3545_20917" x1="133.18" y1="17.8235" x2="146.385" y2="17.8235"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint3_linear_3545_20917" x1="-70.1368" y1="56.2247" x2="220.177" y2="56.2247"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint4_linear_3545_20917" x1="39.8919" y1="103.116" x2="70.4462" y2="103.116"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint5_linear_3545_20917" x1="100.243" y1="46.9939" x2="59.6789" y2="74.0943"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint6_linear_3545_20917" x1="83.9144" y1="47.2389" x2="138.568" y2="66.973"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.03" stop-color="#C45519"/>
                <stop offset="0.08" stop-color="#B0643E"/>
                <stop offset="0.14" stop-color="#9F725E"/>
                <stop offset="0.2" stop-color="#907D79"/>
                <stop offset="0.27" stop-color="#85868F"/>
                <stop offset="0.35" stop-color="#7B8DA0"/>
                <stop offset="0.46" stop-color="#7592AC"/>
                <stop offset="0.6" stop-color="#7295B3"/>
                <stop offset="0.99" stop-color="#7196B5"/>
            </linearGradient>
            <linearGradient id="paint7_linear_3545_20917" x1="77.4535" y1="54.6429" x2="139.565" y2="56.4212"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint8_linear_3545_20917" x1="59.7254" y1="17.3142" x2="-72.1225" y2="105.397"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint9_linear_3545_20917" x1="131.694" y1="61.7788" x2="61.8846" y2="108.417"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint10_linear_3545_20917" x1="65.2811" y1="77.2582" x2="96.6751" y2="77.2582"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint11_linear_3545_20917" x1="83.957" y1="64.7843" x2="91.7872" y2="64.7843"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="0.03" stop-color="#507196"/>
                <stop offset="0.1" stop-color="#5E81B0"/>
                <stop offset="0.18" stop-color="#698EC6"/>
                <stop offset="0.27" stop-color="#7298D7"/>
                <stop offset="0.39" stop-color="#789EE3"/>
                <stop offset="0.55" stop-color="#7CA2EA"/>
                <stop offset="1" stop-color="#7DA4EC"/>
            </linearGradient>
            <linearGradient id="paint12_linear_3545_20917" x1="65.2786" y1="69.3725" x2="83.9566" y2="69.3725"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="0.03" stop-color="#507196"/>
                <stop offset="0.1" stop-color="#5E81B0"/>
                <stop offset="0.18" stop-color="#698EC6"/>
                <stop offset="0.27" stop-color="#7298D7"/>
                <stop offset="0.39" stop-color="#789EE3"/>
                <stop offset="0.55" stop-color="#7CA2EA"/>
                <stop offset="1" stop-color="#7DA4EC"/>
            </linearGradient>
            <linearGradient id="paint13_linear_3545_20917" x1="21.3563" y1="29.0273" x2="-109.793" y2="-11.614"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint14_linear_3545_20917" x1="-5.21484" y1="30.0802" x2="26.7273" y2="30.0802"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.29" stop-color="#A7C4F2"/>
                <stop offset="0.6" stop-color="#CFE3F9"/>
                <stop offset="0.85" stop-color="#E8F6FD"/>
                <stop offset="1" stop-color="#F2FEFF"/>
            </linearGradient>
            <linearGradient id="paint15_linear_3545_20917" x1="25.3254" y1="24.3376" x2="-101.125" y2="1.73265"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint16_linear_3545_20917" x1="44.1934" y1="39.9952" x2="204.06" y2="39.9952"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint17_linear_3545_20917" x1="108.216" y1="84.326" x2="158.611" y2="84.326"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint18_linear_3545_20917" x1="236.275" y1="79.4218" x2="79.0076" y2="104.984"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint19_linear_3545_20917" x1="88.7165" y1="89.4134" x2="103.513" y2="89.4134"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint20_linear_3545_20917" x1="-43.4675" y1="-32.2195" x2="141.765" y2="45.017"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint21_linear_3545_20917" x1="235.861" y1="76.8729" x2="78.5936" y2="102.435"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint22_linear_3545_20917" x1="78.7485" y1="54.9478" x2="14.7963" y2="81.3258"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.03" stop-color="#C45519"/>
                <stop offset="0.08" stop-color="#B0643E"/>
                <stop offset="0.14" stop-color="#9F725E"/>
                <stop offset="0.2" stop-color="#907D79"/>
                <stop offset="0.27" stop-color="#85868F"/>
                <stop offset="0.35" stop-color="#7B8DA0"/>
                <stop offset="0.46" stop-color="#7592AC"/>
                <stop offset="0.6" stop-color="#7295B3"/>
                <stop offset="0.99" stop-color="#7196B5"/>
            </linearGradient>
            <linearGradient id="paint23_linear_3545_20917" x1="82.8942" y1="53.8442" x2="55.3795" y2="65.4199"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint24_linear_3545_20917" x1="60.785" y1="42.7687" x2="136.883" y2="50.5494"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint25_linear_3545_20917" x1="60.2792" y1="47.7185" x2="136.377" y2="55.4992"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint26_linear_3545_20917" x1="61.594" y1="51.9419" x2="34.0775" y2="50.8034"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint27_linear_3545_20917" x1="69.9184" y1="39.1696" x2="44.8036" y2="55.9483"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint28_linear_3545_20917" x1="61.5785" y1="52.2834" x2="34.062" y2="51.1449"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#D14C02"/>
                <stop offset="0.02" stop-color="#D4530D"/>
                <stop offset="0.06" stop-color="#DD6627"/>
                <stop offset="0.11" stop-color="#E4753D"/>
                <stop offset="0.17" stop-color="#E9814E"/>
                <stop offset="0.24" stop-color="#ED895A"/>
                <stop offset="0.34" stop-color="#EF8E61"/>
                <stop offset="0.61" stop-color="#F09063"/>
                <stop offset="0.66" stop-color="#E7906B"/>
                <stop offset="0.75" stop-color="#D19382"/>
                <stop offset="0.86" stop-color="#AC97A7"/>
                <stop offset="0.99" stop-color="#7A9CDA"/>
                <stop offset="1" stop-color="#769DDF"/>
            </linearGradient>
            <linearGradient id="paint29_linear_3545_20917" x1="98.1409" y1="54.5492" x2="127.555" y2="53.6014"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint30_linear_3545_20917" x1="80.1777" y1="44.2951" x2="107.373" y2="44.2951"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="0.03" stop-color="#507196"/>
                <stop offset="0.1" stop-color="#5E81B0"/>
                <stop offset="0.18" stop-color="#698EC6"/>
                <stop offset="0.27" stop-color="#7298D7"/>
                <stop offset="0.39" stop-color="#789EE3"/>
                <stop offset="0.55" stop-color="#7CA2EA"/>
                <stop offset="1" stop-color="#7DA4EC"/>
            </linearGradient>
            <linearGradient id="paint31_linear_3545_20917" x1="103.037" y1="48.5837" x2="138.774" y2="48.5837"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint32_linear_3545_20917" x1="104.312" y1="48.4326" x2="112.269" y2="48.4326"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#4B6C8C"/>
                <stop offset="0.03" stop-color="#507196"/>
                <stop offset="0.1" stop-color="#5E81B0"/>
                <stop offset="0.18" stop-color="#698EC6"/>
                <stop offset="0.27" stop-color="#7298D7"/>
                <stop offset="0.39" stop-color="#789EE3"/>
                <stop offset="0.55" stop-color="#7CA2EA"/>
                <stop offset="1" stop-color="#7DA4EC"/>
            </linearGradient>
            <linearGradient id="paint33_linear_3545_20917" x1="98.2643" y1="58.3584" x2="127.678" y2="57.4106"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <linearGradient id="paint34_linear_3545_20917" x1="98.3175" y1="60.0435" x2="127.731" y2="59.0938"
                            gradientUnits="userSpaceOnUse">
                <stop stop-color="#7DA4EC"/>
                <stop offset="0.03" stop-color="#84AAED"/>
                <stop offset="0.17" stop-color="#9EBFF4"/>
                <stop offset="0.32" stop-color="#B3D0F8"/>
                <stop offset="0.48" stop-color="#C1DBFC"/>
                <stop offset="0.68" stop-color="#CAE2FE"/>
                <stop offset="1" stop-color="#CDE5FF"/>
            </linearGradient>
            <clipPath id="clip0_3545_20917">
                <rect width="165" height="165" rx="8" fill="white"/>
            </clipPath>
        </defs>
    </svg>
);
